import clsx from 'clsx';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { MovesEnum } from 'shared/constants/shared-enums';

import paper from 'assets/png/moves/paper.png?format=webp;avif&as=picture';
import rock from 'assets/png/moves/rock.png?format=webp;avif&as=picture';
import scissors from 'assets/png/moves/scissors.png?format=webp;avif&as=picture';

export const getMoveIcon = (move?: MovesEnum, classes?: string) => {
  switch (move) {
    case MovesEnum.Paper:
      return <OptimizedImage className={clsx(classes)} imageData={paper} alt="paper" />;
    case MovesEnum.Rock:
      return <OptimizedImage className={clsx(classes)} imageData={rock} alt="rock" />;
    case MovesEnum.Scissors:
      return <OptimizedImage className={clsx(classes)} imageData={scissors} alt="scissors" />;
    default:
      return null;
  }
};
